import OfferingProvider from 'providers/offeringProvider/OfferingProvider'
import React from 'react'
import { Outlet } from 'react-router-dom'

const OfferingPage = () => {
  const initData = {}
  return (
    <OfferingProvider initData={initData}>
      <Outlet />
    </OfferingProvider>
  )
}

export default OfferingPage
